import { render, staticRenderFns } from "./ActiveSalons.vue?vue&type=template&id=6b8a9250&scoped=true"
import script from "./ActiveSalons.vue?vue&type=script&lang=js"
export * from "./ActiveSalons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8a9250",
  null
  
)

export default component.exports